export default __webpack_public_path__ + "static/media/mouse.d81dffff.svg";